import React from 'react';

import { addStory } from 'lib/story-books';

import { SingleSelectQuestion } from '.';

addStory('single-select-question', () => <SingleSelectQuestion />);
